import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { Member } from '../domain/member';

const initialState: Member[] = [];

const membersSlice = createSlice({
    initialState,
    name: 'members',
    reducers: {
        
        clearMembers: () => initialState,
        setMembers: (state, action: PayloadAction<Member[]>) => action.payload,
    },
});

export const { setMembers, clearMembers } = membersSlice.actions;
export default membersSlice.reducer;
